module.exports = __webpack_public_path__ + "media/images/logo-outline-black-e1cb6bdc7c26a9aadefd516f87f7cdaa.svg";